import { styled } from '@mui/material/styles';
import { Stack } from 'components/ui';

export const AuthExtraActionsRoot = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  gap: theme.spacing(3),
  width: '100%',
  '&&': {
    marginTop: theme.spacing(5),
  },
}));
